<template>
    <div>
        <a @click="check" class="cursor-pointer">
            <slot>IM A BUTTON</slot>
        </a>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">

                <template slot="header">
                    <slot name="header">slot::header</slot>
                </template>

                <div class="mb-16">
                    <slot name="question">Möchtest du wirklich?</slot>
                </div>

                <div class="flex justify-end">
                    <button-primary @click="confirm()">
                        <slot name="confirm">CONFIRM</slot>
                    </button-primary>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./ButtonPrimary";
import Modal from "../Modal";

export default {
    name: "PanelConfirmDialog",
    components: {ButtonPrimary, Modal},
    props: {
        needConfirmation: {
            type: Boolean,
            default: true,
        },
    },

    data: () => ({
        showModal: false,
    }),

    methods: {
        check() {

            if (!this.needConfirmation) {
                return this.confirm();
            }

            this.showModal = true;
        },
        confirm() {
            this.showModal = false;
            this.$emit('confirmed');
        },
    },
}
</script>

<style scoped>
/* Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.justify-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}

/* Spacing */
.mb-16 {
    margin-bottom: 4rem;
}

/* Cursor */
.cursor-pointer {
    cursor: pointer;
}
</style>
